import React from "react";
import { useState } from "react";
import { Button, Modal, Typography, styled } from "@mui/material";
import { Box } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import axios from "axios";
import {
  successStyle,
  DeleteCancelButton,
  DeleteConfirmButton,
  ButtonNames,
  CloseImg,
  Title,
  PipelineId,
  CautionImg,
  CheckmarkImg,
  ErrorDiv,
  style,
} from "./deletePipelineStyle";
import { ProgressBar } from "../CustomProgressBar/ProgressBar";
import { appInsights } from "../../ApplicationInsightsService";

export const DeletePipelines = ({
  openDeleteModal,
  setOpenDeleteModal,
  pipelineId,
  pipelineName,
  pageNo,
  setPageNo,
  limit,
  setLimit,
  totalCount,
  startAt,
  endAt,
  RequestPipelineData,
}) => {
  const handleClose = () => {
    setOpenDeleteModal(false);
  };
  const [displaySuccess, setDisplaySuccess] = useState(false);
  const { instance, accounts } = useMsal();
  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("");
  const [correlationId, setCorrelationId] = useState("");
  const [displayLoading, setDisplayLoading] = useState(false);

  const handlePipelineDelete = async (event) => {
    appInsights.trackEvent({
      name: `handlePipelineDelete method called for deleting pipelines`,
    });
    event.preventDefault();
    setDisplayLoading(true);
    const url = process.env.REACT_APP_API_URL + "/filetransfer/DeletePipeline";

    const data = {
      PipeLineName: pipelineName,
    };

    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    const accessToken = tokenResponse.accessToken;

    const headers = {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY}`,
      "X-OSF-Caller": `${process.env.REACT_APP_X_OSF_CALLER}`,
    };

    axios
      .delete(url, { data, headers })
      .then((response) => {
        if (response.data.StatusCode === 200) {
          handleClose();
          setDisplayLoading(false);
          setDisplaySuccess(true);
          setTimeout(() => {
            setDisplaySuccess(false);
            if (startAt >= endAt) {
              setPageNo((prevPageNo) => prevPageNo - 1);
            } else {
              RequestPipelineData({
                PageNo: parseInt(pageNo),
                Limit: parseInt(limit),
              });
            }
          }, 2000);
        } else {
          setDisplayLoading(false);
          setCorrelationId(response.headers["x-correlation-id"]);
          setAlertMsg(response.data.Message);
          setAlertSeverity("error");
        }
      })
      .catch((err) => {
        if (err && err.response) {
          setDisplayLoading(false);
          setAlertMsg(err.message);
          setAlertSeverity("error");
          setCorrelationId(err.response.headers["x-correlation-id"]);
        }
      });
  };

  return (
    <>
      {displayLoading ? (
        <ProgressBar />
      ) : (
        <>
          <div>
            <Modal
              open={openDeleteModal}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <div></div>
                <CloseImg
                  onClick={handleClose}
                  src={require("../../images/Close.png")}
                ></CloseImg>
                <Box sx={{ display: "flex-inline" }}>
                  <Title>
                    <center>
                      Are you sure you want to delete Pipeline ID “
                      <PipelineId>{pipelineId}</PipelineId>”
                    </center>
                  </Title>
                </Box>
                <Box>
                  <CautionImg src={require("../../images/CautionRed.png")} />
                </Box>
                <Box>
                  <DeleteCancelButton variant="contained" onClick={handleClose}>
                    <ButtonNames>No</ButtonNames>
                  </DeleteCancelButton>
                </Box>
                <Box>
                  <DeleteConfirmButton
                    variant="contained"
                    onClick={handlePipelineDelete}
                  >
                    <ButtonNames>Yes</ButtonNames>
                  </DeleteConfirmButton>
                </Box>
                <Box>
                  {alertMsg && (
                    <ErrorDiv severity={alertSeverity}>
                      <span>
                        {alertMsg}. Correlation Id : {correlationId}
                      </span>
                    </ErrorDiv>
                  )}
                </Box>
              </Box>
            </Modal>
          </div>
          <div>
            <Modal
              open={displaySuccess}
              onClose={() => setDisplaySuccess(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={successStyle}>
                <Box sx={{ display: "flex-inline" }}>
                  <h1>
                    <center>Pipeline Deleted</center>
                  </h1>
                  <CheckmarkImg
                    onClick={handleClose}
                    src={require("../../images/Checkmark.png")}
                  />
                </Box>
              </Box>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};
